module.exports = __webpack_public_path__ + "static/media/animation2.76816ccd.gif";